import createActionType from "../util/createActionType";

export interface AuthFormState {}

export interface AuthState {}

export const logoutUser = createActionType("logout_user");
